import React, { useState, useEffect } from 'react'

const ScrollableFX = (props) => {
    const [atTop, setAtTop] = useState(true);
    const [atBottom, setAtBottom] = useState(false);

    useEffect(() => {
        const el = props.element.current.dialog.firstChild;
        if (!el) return;

        var body = el.querySelector('.modal-body');
        body.addEventListener('scroll', handleScroll);
        setAtBottom(body.scrollHeight - body.scrollTop === body.clientHeight);

        return () => body.removeEventListener('scroll', handleScroll);
    }, [props.refresh]);

    useEffect(() => {
        const el = props.element.current.dialog.firstChild;
        if (!el) return;

        var header = el.querySelector('.modal-header');
        var footer = el.querySelector('.modal-footer');

        showTopShadow(header);
        atBottom ? footer.classList.add('no-shadow') : footer.classList.remove('no-shadow');
    }, [atTop, atBottom, props.element]);

    const handleScroll = () => {
        const el = props.element.current.dialog.firstChild;
        if (!el) return;

        var body = el.querySelector('.modal-body');

        setAtTop(body.scrollTop === 0);
        setAtBottom(body.scrollHeight - body.scrollTop === body.clientHeight);
    }

    const showTopShadow = (header) => {
        if (atTop) {
            header.classList.add('no-shadow')
        }
        else {
            header.classList.remove('no-shadow');
        }
    }

    return (
        <>
        </>
    );
};

export default ScrollableFX;